import { useState, useEffect, MouseEvent } from 'react';
import {
  Dialog,
  DialogTitle,
  ToggleButton,
  DialogContent,
  DialogContentText,
  ToggleButtonGroup,
} from '@mui/material';

import { CopyMode, copyMode, CopyDialogProps } from './types';

export const CopyDialog = ({
  open,
  title,
  onClose,
  descriptions,
  crossEnvForm,
  currentEnvForm,
}: CopyDialogProps) => {
  const [mode, setMode] = useState<CopyMode>(copyMode.currentEnv);

  useEffect(() => {
    if (open) {
      setMode(copyMode.currentEnv);
    }
  }, [open]);

  const handleModeChange = (
    _: MouseEvent<HTMLElement>,
    newMode: CopyMode | null
  ) => {
    if (newMode) {
      setMode(newMode);
    }
  };

  return (
    <Dialog fullWidth open={open} maxWidth="sm" onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {typeof descriptions === 'string' ? descriptions : descriptions[mode]}
        </DialogContentText>

        <ToggleButtonGroup
          exclusive
          value={mode}
          className="mt-6 w-full"
          onChange={handleModeChange}
        >
          <ToggleButton className="flex-1" value={copyMode.currentEnv}>
            Current environment
          </ToggleButton>
          <ToggleButton className="flex-1" value={copyMode.crossEnv}>
            Cross-environment
          </ToggleButton>
        </ToggleButtonGroup>

        {mode === copyMode.currentEnv ? currentEnvForm : crossEnvForm}
      </DialogContent>
    </Dialog>
  );
};

export { CrossEnvCopyForm } from './cross-env-copy-form';
export type { CrossEnvBaseValues } from './cross-env-copy-form';
